import { useTheme } from '@mui/material';

export const useCardSx = () => {
  const theme = useTheme();
  return {
    borderRadius: 1,
    border: '1px solid',
    borderColor: theme.colors.border.menuButton,
    p: 5,
  } as const;
};
